import {CoapCollectorDbReader, ConnectionLogDbReader, ConnectionTestDbReader} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public CoapCollectorDbReader: CoapCollectorDbReader,
    public ConnectionLogDbReader: ConnectionLogDbReader,
    public ConnectionTestDbReader: ConnectionTestDbReader,
  ) {}
}